export default {"src":"/_next/static/media/logo-15.ad014970.svg","height":52,"width":51,"blurWidth":0,"blurHeight":0};